import { render } from "./ViewsSurveysViewProductChoice.vue?vue&type=template&id=1dccdb31"
import script from "./ViewsSurveysViewProductChoice.vue?vue&type=script&lang=js"
export * from "./ViewsSurveysViewProductChoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__